import * as tslib_1 from "tslib";
import { OnInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CruiseService } from "../../services/cruise.service";
// Servicios de la API GALAVAIL
import { GalavailServiceEcommer, SearchService } from "clientwsGalavail";
// Servicios NGFlow
import { NgWebflowService } from "ngweflow";
import { SearchStatusEnum } from "../../enums/search-status.enum";
import { environment } from "../../../environments/environment";
// --
import { Location, PlatformLocation } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { CompanyService } from "src/app/services/company/company.service";
import { OptionHeaderStyleEnum } from "../../enums/option-header-style.enum";
import { ShareModalComponent } from "./share-modal/share-modal.component";
import { isNullOrUndefined } from "util";
import { WebFlowAction } from "src/app/core/enums/web-flow-actions.enum";
import { UtilDate } from "src/app/shared/util/util-date";
import { isNumeric } from 'rxjs/util/isNumeric';
var ResultsComponent = /** @class */ (function () {
    function ResultsComponent(activatedRoute, cruiseService, galavailServiceEcommer, router, ngWebflowService, document, renderer2, location, platformLocation, dialog, searchService, companyService, utilDate) {
        this.activatedRoute = activatedRoute;
        this.cruiseService = cruiseService;
        this.galavailServiceEcommer = galavailServiceEcommer;
        this.router = router;
        this.ngWebflowService = ngWebflowService;
        this.document = document;
        this.renderer2 = renderer2;
        this.location = location;
        this.platformLocation = platformLocation;
        this.dialog = dialog;
        this.searchService = searchService;
        this.companyService = companyService;
        this.utilDate = utilDate;
        this.optionEnum = OptionHeaderStyleEnum;
        this.totalCruises = [];
        this.env = environment;
        this.todayDate = new Date().getFullYear();
        this.fechaTemp = [];
        this.listadoMeses = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];
        this.listadoMesesn = [
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
        ];
        this.mesBusqueda = ""; // se registra el nombre del mes
        this.mes = 0; // se registra el numero equivalente al mes
        this.monthNames = [
            "JAN",
            "FEB",
            "MAR",
            "APR",
            "MAY",
            "JUN",
            "JUL",
            "AUG",
            "SEP",
            "OCT",
            "NOV",
            "DEC",
        ];
        this.titlecaseMonthNames = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        this.dayNames = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        // public codigoBarco = AppConstantes.ALL_BARCO;
        this.totalSearch = 0;
        this.finished = false; // boolean when end of database is reached
        this.searchStatusEnum = SearchStatusEnum;
        this.dateToday = new Date();
        this.logoCruise = environment.appResource.logoCruise;
        this.companyLogo = environment.appResource.companyLogos;
        this.textAlart = "";
        this.visibleAlertText = false;
        this.adiotionalServicesMaping = [];
        this.isVisibleDialog = false;
        this.paramsUrl = this.activatedRoute.snapshot.params;
        this.empresa = this.paramsUrl.company;
        this.dias = decodeURIComponent(this.paramsUrl.days);
        this.passengers = this.validatePassenger(this.paramsUrl.paxs);
        this.fecha = this.paramsUrl.monthYear;
        this.category = this.paramsUrl.boat;
        this.isCharterOnly = this.paramsUrl.paxs === "charterOnly";
        this.pagina = 1;
        this.searchStatus = this.searchStatusEnum.INIT;
        console.log("STATUS:", this.searchStatus);
        this.isSearching = false;
        this.cargarMas = false;
        this.noMoreResults = false;
        this.dateRangeFromURL = this.paramsUrl.daterange.split("-");
        this.dateFrom = this.dateRangeFromURL[0];
        this.dateTo = this.dateRangeFromURL[1];
        this.urlShare = "";
        this.messageCopied = false;
    }
    ResultsComponent.prototype.ngOnInit = function () {
        // =============================
        // Load 279390 Sojern Tag v6_js, Pixel Version: 1
        try {
            this.fillrequestdata();
        }
        catch (error) {
            this.fillrequestdata();
        }
    };
    ResultsComponent.prototype.fillrequestdata = function () {
        var _this = this;
        var srcScript = this.renderer2.createElement("script");
        srcScript.type = "text/javascript";
        srcScript.text = "\n    (function () {\n        console.log('>>>>> Load Script 279390');\n        /* Please fill the following values. */\n        var params = {\n          vd1: \"\", /* Departure Date */\n          vd2: \"\", /* Return Date */\n          vf1: \"\", /* Destination City */\n          vs1: \"\", /* Destination State or Region */\n          vn1: \"\", /* Destination Country */\n          t: \"\" /* Number of Travelers */\n        };\n\n        /* Please do not modify the below code. */\n        var cid = [];\n        var paramsArr = [];\n        var cidParams = [];\n        var pl = document.createElement('script');\n        var defaultParams = {\"vid\":\"tou\",\"et\":\"vs\"};\n        for(key in defaultParams) { params[key] = defaultParams[key]; };\n        for(key in cidParams) { cid.push(params[cidParams[key]]); };\n        params.cid = cid.join('|');\n        for(key in params) { paramsArr.push(key + '=' + encodeURIComponent(params[key])) };\n        pl.type = 'text/javascript';\n        pl.async = true;\n        pl.src = 'https://beacon.sojern.com/pixel/p/279390?f_v=v6_js&p_v=1&' + paramsArr.join('&');\n        (document.getElementsByTagName('head')[0] ||\n        document.getElementsByTagName('body')[0]).appendChild(pl);\n      })();\n      ";
        this.renderer2.appendChild(this.document.body, srcScript);
        // =============================
        this.totalCruises = [];
        this.mostrarContenedorResultados = false;
        this.mostrarLoading = true;
        this.children = 0;
        this.generateKeyCompany();
        this.galavailServiceEcommer.findCompany(this.requestCompany).subscribe(function (response) {
            _this.datesCompany = response;
            //console.log('EMPRESA', this.datesCompany);
            _this.companyService.setCompany(response);
            _this.nameCompanyFooter = _this.datesCompany.name;
            _this.mailTo = "mailto:" + _this.datesCompany.infoEmail;
            _this.dataCodeEncrypt = encodeURIComponent(_this.datesCompany.code);
            _this.cargarValoresPLantilla();
            _this.prepareAndThenExecuteSearch();
            _this.setearParametrosLocalStorage();
            _this.textAlart = "You can only place a hold using this method when there are " + _this.companyService.getNumberVisibleOnHold() + " or more spaces available. Please contact your Account Manager directly to place a hold or email: " + _this.companyService.getInfoEmail() + ". Thanks";
            _this.setScripts();
            _this.setBodyScripts();
            _this.whatsappNumber = _this.companyService.getCompanyParams().whatsappNumber;
        }, function (error) {
            // console.log(error.error.date);
        });
    };
    ResultsComponent.prototype.setScripts = function () {
        this.companyService.getScripts().forEach(function (item) {
            var head = document.createElement("script");
            head.type = "text/javascript";
            head.src = item.srcLinks;
            document.head.appendChild(head);
        });
    };
    ResultsComponent.prototype.setBodyScripts = function () {
        this.companyService.getBodyScripts().forEach(function (item) {
            var body = document.createElement("script");
            body.type = "text/javascript";
            body.src = item.srcLinks;
            document.body.appendChild(body);
        });
    };
    ResultsComponent.prototype.prepareAndThenExecuteSearch = function () {
        this.getSearchRequestObject();
        this.executeSearch();
    };
    ResultsComponent.prototype.getSearchRequestObject = function () {
        // console.log('ARAMDO DE OBJETO en pagina' + this.pagina );
        if (this.dias === "All") {
            this.dias = "0";
        }
        if (this.category.toString() === "All") {
            this.category = 0;
            this.boat = 0;
        }
        else {
            if (this.category == 5 ||
                this.category == 4 ||
                this.category == 3 ||
                this.category == 2) {
                this.boat = 0;
                // console.log('CATEGORIA ++++++++++++++++++');
            }
            else {
                // console.log('BARCO **********************');
                var tempBoat = this.category;
                this.boat = tempBoat;
                this.category = 0;
            }
        }
        /*this.fechaTemp = this.fecha.split("-");
        if (this.fechaTemp[1] === "All") {
          this.mesTemp = "0";
        } else {
          for (let m = 0; m <= this.listadoMeses.length; m++) {
            if (this.listadoMeses[m] === this.fechaTemp[1]) {
              this.mesTemp = this.listadoMesesn[m];
            }
          }
        }
        this.yearTemp = this.fechaTemp[0]
    
        this.validateMonth();
        this.validateYear();*/
        this.validateDateRange();
        var myrequest = {
            code: this.datesCompany.code,
            //month: Number(this.mesTemp),
            //year: this.yearTemp,
            adults: Number(this.passengers),
            children: Number(this.children),
            category: this.category,
            type: 0,
            length: Number(this.dias),
            lengths: this.dias,
            boat: this.boat,
            order: 4,
            page: this.pagina,
            promotions: [],
            groupsOnly: false,
            charterOnly: this.isCharterOnly,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo,
        };
        this.requestSearch = myrequest;
        // console.log('myrequest:::::', this.requestSearch);
    };
    ResultsComponent.prototype.validateMonth = function () {
        var today = new Date();
        if (this.mesTemp) {
            if (this.mesTemp != "0") {
                if ((Number(this.mesTemp) < today.getMonth() + 1) && Number(this.yearTemp) < today.getFullYear()) {
                    this.implementNavigateCorrectedUrl();
                }
            }
        }
        else {
            this.implementNavigateCorrectedUrl();
        }
    };
    ResultsComponent.prototype.validateYear = function () {
        var today = new Date();
        if (!isNullOrUndefined(this.yearTemp) &&
            this.yearTemp != "null" &&
            this.yearTemp != "undefined") {
            if (Number(this.yearTemp) < today.getFullYear()) {
                this.implementNavigateCorrectedUrl();
            }
        }
        else {
            this.implementNavigateCorrectedUrl();
        }
    };
    ResultsComponent.prototype.validateDateRange = function () {
        var today = new Date();
        var todayPlusOneMonth = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
        if (this.dateFrom.length == 8 && isNumeric(this.dateFrom)) {
        }
        else {
            if (this.dateFrom.length == 4 && isNumeric(this.dateFrom)) {
                var year = this.dateFrom;
                if (this.dateTo.length == 3 && this.titlecaseMonthNames.includes(this.dateTo)) {
                    var month = this.titlecaseMonthNames.indexOf(this.dateTo);
                    this.dateFrom = this.utilDate.formatDate(new Date(Number(year), month, today.getDate()));
                    this.dateTo = this.utilDate.formatDate(new Date(Number(year), month + 1, todayPlusOneMonth.getDate()));
                }
                else {
                    this.dateFrom = this.utilDate.formatDate(new Date(Number(year), today.getMonth(), today.getDate()));
                    this.dateTo = this.utilDate.formatDate(new Date(Number(year), todayPlusOneMonth.getMonth(), todayPlusOneMonth.getDate()));
                }
            }
            else {
                this.dateFrom = this.utilDate.formatDate(today);
                this.dateTo = this.utilDate.formatDate(todayPlusOneMonth);
            }
            this.implementNavigateCorrectedUrl();
        }
    };
    ResultsComponent.prototype.implementNavigateCorrectedUrl = function () {
        var today = new Date();
        //const monthValue = this.listadoMeses[today.getMonth()];
        //const yearValue = today.getFullYear();
        //const stringDate = today.getFullYear() + "-" + monthValue;
        // Preservar el valor original de pasajeros incluyendo charterOnly
        var passengersParam = this.isCharterOnly ? "charterOnly" : (this.passengers || "2");
        this.router.navigate([
            this.empresa,
            this.boat == 0 ? "All" : this.boat,
            Number(this.dias) == 0 ? "All" : this.dias,
            this.dateFrom + '-' + this.dateTo,
            passengersParam,
        ]);
        /*this.mesTemp = String(today.getMonth() + 1);
        this.yearTemp = yearValue.toString();
        console.log("222", this.yearTemp);*/
        this.setSearchObj();
        this.executeSearch();
    };
    ResultsComponent.prototype.setSearchObj = function () {
        var myRequestNew = {
            code: this.datesCompany.code,
            //month: Number(this.mesTemp) + 1,
            //year: this.yearTemp,
            adults: this.passengers,
            children: this.children,
            category: this.category,
            type: 0,
            length: Number(this.dias),
            lengths: this.dias,
            boat: this.boat,
            order: 4,
            page: this.pagina,
            charterOnly: this.isCharterOnly,
            groupsOnly: false,
            promotions: false,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo
        };
        this.requestSearch = tslib_1.__assign({}, myRequestNew);
    };
    ResultsComponent.prototype.executeSearch = function () {
        var _this = this;
        this.isSearching = true;
        this.searchStatus = this.searchStatusEnum.SEARCHING;
        this.galavailServiceEcommer
            .findAvailability(this.requestSearch)
            .subscribe(function (response) {
            var e_1, _a;
            _this.ngWebflowService.addWebFlowAction(WebFlowAction.SEARCH, _this.requestSearch);
            // console.log('response execute', response);
            _this.mostrarLoading = false;
            _this.labelAvailabilityFormat(_this.dateFrom, _this.dateTo);
            // console.log('PAGE EXECUTE: ', this.pagina);
            if (response.length > 0) {
                _this.mostrarContenedorResultados = true;
                _this.cruises = response;
                _this.isSearching = false;
                try {
                    // Concatenamos el resultado actual al arreglo total principal
                    for (var response_1 = tslib_1.__values(response), response_1_1 = response_1.next(); !response_1_1.done; response_1_1 = response_1.next()) {
                        var c1 = response_1_1.value;
                        _this.totalCruises.push(c1);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (response_1_1 && !response_1_1.done && (_a = response_1.return)) _a.call(response_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                _this.totalSearch = _this.totalCruises.length;
                _this.cargarMas = false;
            }
            else {
                // variable spara indicar que no hay mas resultados
                if (_this.pagina == 1) {
                    // console.log('pagina 1 quedo');
                    _this.searchStatus = _this.searchStatusEnum.NO_RESULTS;
                    _this.cargarMas = false;
                }
                else {
                    _this.searchStatus = _this.searchStatusEnum.NO_MORE_RESULTS;
                    _this.cargarMas = false;
                }
                _this.isSearching = false;
                _this.noMoreResults = false;
            }
            // console.log('Search STATUS', this.searchStatus);
            //console.log('total registros', this.totalSearch);
            // console.log('cruises total', this.totalCruises);
        });
    };
    ResultsComponent.prototype.recibirDatos = function (event) {
        //control para la renderizaci[on de resultados
        this.isCharterOnly = event.charterOnly;
        // console.log('RECIBIENDO DATOS DEL COMPONENTE HIJO BUSQUEDA');
        this.searchStatus = this.searchStatusEnum.INIT;
        // console.log('STATUS:', this.searchStatus);
        // console.log('DATOS: ', event);
        this.pagina = 1;
        this.totalSearch = 0;
        this.dataUrl = event;
        if (event.dias === "All") {
            this.diasUrl = event.dias;
            this.dias = "0";
        }
        else {
            this.dias = event.dias;
        }
        if (event.barco.toString() === "All") {
            this.categoryUrl = event.barco;
            this.category = 0;
            this.boat = 0;
        }
        else {
            if (event.barco == 5 ||
                event.barco == 4 ||
                event.barco == 3 ||
                event.barco == 2) {
                this.category = event.barco;
                this.boat = 0;
            }
            else {
                // console.log('*****************AAAAAAAAAA');
                this.boat = event.barco;
                this.category = 0;
            }
        }
        // console.log('CATEGORIA', this.category);
        //this.fechaTemp = event.fecha.split("-");
        // console.log(this.fechaTemp);
        /*if (this.fechaTemp[1] === "All") {
          this.mesTemp = "0";
        } else {
          for (let m = 0; m <= this.listadoMeses.length; m++) {
            if (this.listadoMeses[m] === this.fechaTemp[1]) {
              this.mesTemp = this.listadoMesesn[m];
            }
          }
        }*/
        this.passengers = event.pasajeros;
        this.dateFrom = event.dateFrom;
        this.dateTo = event.dateTo;
        var myRequestNew = {
            code: this.datesCompany.code,
            //month: Number(this.mesTemp),
            //year: this.fechaTemp[0],
            adults: this.passengers,
            children: this.children,
            category: this.category,
            type: 0,
            length: Number(this.dias),
            lengths: this.dias,
            boat: this.boat,
            order: 4,
            page: this.pagina,
            charterOnly: event.charterOnly,
            groupsOnly: event.groupsOnly,
            promotions: event.promotions,
            dateFrom: this.dateFrom,
            dateTo: this.dateTo
        };
        this.requestSearch = myRequestNew;
        // console.log('newrequestsearch', this.requestSearch);
        this.totalCruises = [];
        this.executeSearch();
    };
    ResultsComponent.prototype.onScroll = function () {
        if (this.isSearching || this.noMoreResults) {
            return 0;
        }
        this.pagina++;
        // console.log('PAGE: ', this.pagina);
        this.cargarMas = true;
        // console.log('BARCO SCROLL', this.boat);
        // console.log('CATE SCROLL', this.category);
        // console.log('DIAS SCROLL', this.dias);
        if (this.searchStatus !== this.searchStatusEnum.NO_MORE_RESULTS &&
            this.searchStatus !== this.searchStatusEnum.NO_RESULTS) {
            this.executeSearchOnScroll();
        }
        else {
            this.cargarMas = false;
        }
        // this.executeSearchOnScroll();
    };
    ResultsComponent.prototype.executeSearchOnScroll = function () {
        var categoriaScroll = this.category;
        var barcoScroll = this.boat;
        var diasScroll = this.dias;
        // console.log('categoriaScroll', categoriaScroll);
        // console.log('barcoScroll', barcoScroll);
        // console.log('diasScroll', diasScroll);
        if (this.dias === "All") {
            this.dias = "0";
        }
        if (this.category.toString() === "All") {
            this.category = 0;
            this.boat = 0;
        }
        else {
            if (this.category == 5 ||
                this.category == 4 ||
                this.category == 3 ||
                this.category == 2) {
                this.boat = 0;
            }
            else {
                var tempBoat = this.category;
                // this.boat = tempBoat;
                this.boat = barcoScroll;
                // console.log('>>>>', this.boat);
                this.category = 0;
            }
        }
        var myrequestOnScroll = tslib_1.__assign({}, this.requestSearch, { code: this.datesCompany.code, 
            //month: Number(this.mesTemp),
            //year: this.fechaTemp[0],
            adults: this.passengers, children: this.children, category: this.category, type: 0, length: Number(this.dias), lengths: this.dias, boat: this.boat, order: 4, page: this.pagina, dateFrom: this.dateFrom, dateTo: this.dateTo });
        this.requestSearch = myrequestOnScroll;
        // console.log('PAGINA', this.pagina);
        // console.log('newrequestsearch onScroll', this.requestSearch);
        this.executeSearch();
    };
    ResultsComponent.prototype.cargarValoresPLantilla = function () {
        // console.log('**********');
        // console.log('empresa', this.empresa);
        this.nameLogo = "logo1.png";
        this.nombreEmpresa = this.empresa;
        this.colorPrimario = "#" + this.datesCompany.mainColor;
        this.colorSecundario = "#" + this.datesCompany.secondaryColor;
        this.colorCabecera = "#" + this.datesCompany.headercolor;
        this.colorPie = "#" + this.datesCompany.footerColor;
        // if (this.empresa === 'royal') {
        //   this.nameLogo = 'logo1.png';
        //   this.nombreEmpresa = this.empresa;
        //   this.colorPrimario = '#' + this.datesCompany.mainColor;
        //   this.colorSecundario = '#' + this.datesCompany.secondaryColor;
        //   this.colorCabecera = '#' + this.datesCompany.headerColor;
        //   this.colorPie = '#' + this.datesCompany.footerColor;
        // } else {
        //   this.router.navigate(['error/400']);
        // }
    };
    ResultsComponent.prototype.ocultarContendorResultados = function (event) {
        this.mostrarContenedorResultados = event;
    };
    ResultsComponent.prototype.showLoading = function (eventL) {
        this.mostrarLoading = eventL;
    };
    ResultsComponent.prototype.generateKeyCompany = function () {
        // const formatedDateToday: string = this.dateToday.getFullYear().toString() + '0' + (this.dateToday.getMonth() + 1) + '0' + this.dateToday.getDate();
        // const formatedDateToday: string = this.dateToday.getFullYear().toString() + formatMonth + formatDay;
        // const encodeDate = window.btoa(formatedDateToday);
        var encodeDate = window.btoa(this.getFormatedDateToday());
        // console.log('encodeDate', encodeDate);
        // console.log('$$$$$$$$$$$$$$$$$$$$$$$$$$$$$');
        // const encodeCompany = window.btoa( encodeDate + ',royal' );
        var encodeCompany = window.btoa(encodeDate + "," + this.empresa);
        // console.log('nombre EMPRESA', this.empresa);
        // console.log('encodeCompany', encodeCompany);
        this.requestCompany = {
            key: encodeCompany,
        };
        return this.requestCompany;
    };
    ResultsComponent.prototype.getFormatedDateToday = function () {
        var formatedDateToday;
        var tempMonth = this.dateToday.getMonth() + 1;
        var tempDay = this.dateToday.getDate();
        var formatMonth;
        var formatDay;
        if (tempMonth > 0 && tempMonth < 10) {
            formatMonth = "0" + tempMonth;
        }
        else {
            formatMonth = tempMonth.toString();
        }
        if (tempDay > 0 && tempDay < 10) {
            formatDay = "0" + tempDay;
        }
        else {
            formatDay = tempDay.toString();
        }
        formatedDateToday =
            this.dateToday.getFullYear().toString() + formatMonth + formatDay;
        return formatedDateToday;
    };
    ResultsComponent.prototype.setearParametrosLocalStorage = function () {
        this.galavailServiceEcommer.setLocalStorage("paleta-" + this.datesCompany.code, this.datesCompany);
        this.galavailServiceEcommer.setLocalStorage("urlOrigen-" + this.datesCompany.code, this.empresa +
            "/" +
            this.categoryUrl +
            "/" +
            this.diasUrl +
            "/" +
            this.fecha +
            "/" +
            this.passengers);
    };
    ResultsComponent.prototype.setSelectedOption = function (cruise, avail) {
        console.log("select");
        this.selectedCruise = cruise;
        this.selectedAvailability = avail;
    };
    ResultsComponent.prototype.setParametersInquire = function (code, empresa, boat, promotion, contPromotion, rackPrice, promoPrice, startDate, endDate, length, lengths, nameIti, passengers, startEndDates, logoBoat, imageBoat, aditionalServices, charterOnly, groupsOnly) {
        this.selectedCruise;
        // console.log('>>>> ', contPromotion);
        var textTempContPromotion = "";
        /*if ( promotion === 'Regular Rate' ) {
          textTempContPromotion = '(free hotel night & 1 transfer)';
        } else {
          textTempContPromotion = '+ free hotel night & 1 transfer*';
        }*/
        /*if ( contPromotion === 'Charter' ) {
          promotion += ' - ' + contPromotion;
          textTempContPromotion = contPromotion;
        }*/
        this.selectedCode = code;
        textTempContPromotion = contPromotion;
        startDate = startDate.replace(" 12:00:00 AM", "");
        endDate = endDate.replace(" 12:00:00 AM", "");
        this.dataInquire = {
            empresa: empresa,
            boat: boat,
            promotion: promotion,
            textTempContPromotion: textTempContPromotion,
            rackPrice: rackPrice,
            promoPrice: promoPrice,
            startDate: startDate,
            endDate: endDate,
            length: length,
            lengths: lengths,
            nameIti: nameIti,
            passengers: passengers,
            startEndDates: startEndDates,
            logoBoat: logoBoat,
            imageBoat: imageBoat,
            aditionalServices: aditionalServices,
            charterOnly: charterOnly,
            groupsOnly: groupsOnly,
        };
        this.galavailServiceEcommer.setLocalStorage("dataInquire-" + this.datesCompany.code, this.dataInquire);
    };
    ResultsComponent.prototype.calculateTotalCabins = function (nameDeck, listCabins, status) {
        var tmpContCabin = 0;
        if (listCabins.length > 0) {
            for (var cab = 0; cab < listCabins.length; cab++) {
                if (listCabins[cab]["deck"] === nameDeck &&
                    listCabins[cab]["status"] === status) {
                    tmpContCabin += listCabins[cab]["capacity"];
                }
            }
            return tmpContCabin;
        }
        else {
            return tmpContCabin;
        }
    };
    /**
     * Metodo que nos valida si en la url el parametro pasajero es un valor numerico en el rango permitido
     * @param valuePax
     */
    ResultsComponent.prototype.validatePassenger = function (valuePax) {
        var tempValue;
        var returnValue;
        tempValue = Number(valuePax);
        return tempValue;
    };
    /**
     * Metodo que no ayuda a verificar si el color del pie es claro u oscuro,
     * esto se lo aplica para dar cierto estilos en el div
     * @param hexcolor
     */
    ResultsComponent.prototype.isTooDark = function (hexcolor) {
        if (hexcolor != null) {
            var r = parseInt(hexcolor.substr(1, 2), 16);
            var g = parseInt(hexcolor.substr(3, 2), 16);
            var b = parseInt(hexcolor.substr(4, 2), 16);
            var yiq = (r * 299 + g * 587 + b * 114) / 1000;
            // Return new color if to dark, else return the original
            // return (yiq < 40) ? '#2980b9' : hexcolor;
            return yiq < 150;
        }
        else {
            return false;
        }
    };
    // ***************************************************
    // **** METODOS PARA COMPARTIR
    /**
     *
     * @param dataBoat
     * @param dataDeparture
     */
    ResultsComponent.prototype.createUrltoShare = function (dataBoat, dataDeparture) {
        this.messageCopied = false;
        console.log("BOAT-----", dataBoat);
        console.log("DEPARTURE:::::", dataDeparture);
        console.log("(this.platformLocation as any).location.host", this.platformLocation.location.host);
        // this.urlShare = (this.platformLocation as any).location.host + (this.platformLocation as any).location.pathname;
        this.urlShare =
            this.platformLocation.location.host +
                "/" +
                this.empresa +
                "/" +
                dataBoat.name +
                "/" +
                dataDeparture.length.substr(0, 1) +
                "/" +
                this.fecha +
                "/" +
                this.passengers;
        console.log("createurl", window.location.href);
        this.urlShare = encodeURI(this.urlShare);
        this.isOpenShareDialog = true;
    };
    /**
     *
     */
    ResultsComponent.prototype.clipboardAction = function () {
        this.clipboardmyMessage(this.urlShare);
        // alert('Copied to clipboard ');
        this.messageCopied = true;
    };
    /**
     *
     * @param val
     */
    ResultsComponent.prototype.clipboardmyMessage = function (val) {
        var selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = val;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
    };
    /**
     *
     * @param sharein
     */
    ResultsComponent.prototype.getLink = function (sharein) {
        var response = "";
        switch (sharein) {
            case "facebook": {
                response =
                    "https://www.facebook.com/sharer/sharer.php?u=" + this.urlShare;
                break;
            }
            case "twitter": {
                response = "https://twitter.com/intent/tweet/?text=" + this.urlShare;
                break;
            }
            case "google": {
                response = "https://plus.google.com/share?url=" + this.urlShare;
                break;
            }
            case "whatsapp": {
                response = "https://wa.me/?text=" + encodeURIComponent(this.urlShare);
                break;
            }
            case "email": {
                response =
                    "mailto:?subject=Availability%20Galavail.&amp;body=" +
                        encodeURIComponent(this.urlShare);
                break;
            }
            case "pinterest": {
                response =
                    "https://pinterest.com/pin/create/button/?url=" +
                        encodeURIComponent(this.urlShare) +
                        "&media=" +
                        encodeURIComponent(this.imageUrl) +
                        "&description=" +
                        encodeURIComponent("Availability Galavail");
                break;
            }
        }
        return response;
    };
    /**
     *
     * @param dataBoat
     * @param dataDeparture
     */
    ResultsComponent.prototype.openDialogShare = function (dataBoat, dataDeparture) {
        this.urlShare =
            this.platformLocation.location.host +
                "/" +
                this.empresa +
                "/" +
                dataBoat.name +
                "/" +
                dataDeparture.length.substr(0, 1) +
                "/" +
                this.fecha +
                "/" +
                this.passengers;
        var dialogRef = this.dialog.open(ShareModalComponent, {
            data: {
                dataUrl: this.urlShare,
            },
        });
        dialogRef.afterClosed().subscribe(function (result) {
            console.log("The dialog was closed");
        });
    };
    // ***************************************************
    ResultsComponent.prototype.goAndValidateOnhold = function (c) {
        if (c.groupsOnly && this.datesCompany.visibleOnHold && !c.charterOnly) {
            if (c.boat.minimumGroupOnly < this.datesCompany.maximumCabinOnHold * 2) {
                this.validationWithNumberVisibleHold(c);
            }
            else {
                this.visibleAlertText = true;
                //alert(this.textAlart);
            }
        }
        else {
            this.validationWithNumberVisibleHold(c);
        }
    };
    ResultsComponent.prototype.validationWithNumberVisibleHold = function (c) {
        var url = this.empresa + "/onhold/" + this.dataCodeEncrypt + "/" + this.selectedCode + "/";
        if (c.avail >= this.companyService.getNumberVisibleOnHold() &&
            !c.charterOnly) {
            console.log("vanigate", url);
            window.location.href = url;
            // this.router.navigate([url]);
        }
        else {
            this.visibleAlertText = true;
            //alert(this.textAlart);
        }
    };
    ResultsComponent.prototype.hasHotel = function (cruise) {
        if (this.hasWordInSA("HOTEL", cruise) ||
            this.hasWordInSA("HOTELS", cruise)) {
            return true;
        }
        else {
            return false;
        }
    };
    ResultsComponent.prototype.hasTransfer = function (avail) {
        if (this.hasWordInSA("TRANSFER", avail) ||
            this.hasWordInSA("TRANSFERS", avail)) {
            return true;
        }
        else {
            return false;
        }
    };
    ResultsComponent.prototype.hasAirTicket = function (avail) {
        if (this.hasWordInSA("TICKET", avail) ||
            this.hasWordInSA("TICKETS", avail)) {
            return true;
        }
        else {
            return false;
        }
    };
    ResultsComponent.prototype.hasWordInSA = function (word, avail) {
        var myArrayOFAdServ = [];
        var resp = false;
        var index = -1; // no existe
        myArrayOFAdServ = avail.aditionalServices;
        for (var i = 0; i < myArrayOFAdServ.length; i++) {
            index = myArrayOFAdServ[i].toUpperCase().indexOf(word);
            if (index >= 0) {
                resp = true;
                break; // finish
            }
        }
        return resp;
    };
    ResultsComponent.prototype.setIsPromoOnly = function (event) {
        this.isPromoOnly = event;
    };
    ResultsComponent.prototype.addLogPrintResults = function () {
        this.ngWebflowService.addWebFlowAction(WebFlowAction.PRINT_RESULTS, {});
    };
    ResultsComponent.prototype.labelAvailabilityFormat = function (dateFrom, dateTo) {
        var datefrom = this.utilDate.formatStringToDate(dateFrom);
        var dateto = this.utilDate.formatStringToDate(dateTo);
        var monthFrom = datefrom.toLocaleString('en', { month: 'short' });
        var monthTo = dateto.toLocaleString('en', { month: 'short' });
        if (datefrom.getFullYear() != dateto.getFullYear()) {
            this.dateRange = this.capitalize(monthFrom) + " " + datefrom.getDate() + ", " + datefrom.getFullYear() + " - " + this.capitalize(monthTo) + " " + dateto.getDate() + ", " + dateto.getFullYear();
        }
        else if (datefrom.getMonth() != dateto.getMonth()) {
            this.dateRange = this.capitalize(monthFrom) + " " + datefrom.getDate() + " - " + this.capitalize(monthTo) + " " + dateto.getDate() + ", " + datefrom.getFullYear();
        }
        else {
            this.dateRange = this.capitalize(monthFrom) + " " + datefrom.getDate() + " - " + dateto.getDate() + ", " + datefrom.getFullYear();
        }
    };
    ResultsComponent.prototype.capitalize = function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    };
    return ResultsComponent;
}());
export { ResultsComponent };
